<template>
    <div class="layout-admin">
        <div class="navigation bg-primary  mh-100 ">
            <img src="../../assets/logo.svg" title="سامانه پارسیان نسخه 1.0"
                 style="width: 25px; margin-top: 8px; margin-right: 15px; margin-bottom: 18px">

            <div style="height: calc(100vh - 110px)">


                <b-nav v-if="$auth.check()">
                    <b-nav-item :to="{name:'pageDashboard'}" class=" navigation-item">
                        <i class="fa fa1 fa-home text-light  fa-fw" aria-hidden="true"/>
                    </b-nav-item>

                    <b-nav-item :to="{name:'pageUser'}" class=" navigation-item">
                        <i class="fa fa1 fa-user text-light  fa-fw" aria-hidden="true"/>
                    </b-nav-item>

                    <b-nav-item :to="{name:'pageAgencie'}" class=" navigation-item">
                        <i class="fa fa2 fa-user-circle-o  fa-fw text-light" aria-hidden="true"/>
                    </b-nav-item>

                    <!-- <b-nav-item :to="{name:'pageCertificate'}" class=" navigation-item"  >
                        <i class="fa fa1 fa-certificate    text-light  fa-fw" aria-hidden="true"/>
                    </b-nav-item> -->


                    <!-- <b-nav-item :to="{name:'pageCustomer'}" class=" navigation-item" >
                        <i class="fa fa2 fa-users  text-light  fa-fw" aria-hidden="true"/>
                    </b-nav-item> -->

                    <!-- <b-nav-item :to="{name:'pageDownload'}" class=" navigation-item" >
                        <i class="fa fa1 fa-download    text-light  fa-fw" aria-hidden="true"/>
                    </b-nav-item> -->

                    <b-nav-item :to="{name:'pageProduct'}" class=" navigation-item" :active="$route.name == 'pageProductCategory'" >
                        <i class="fa fa1 fa-shopping-cart  text-light  fa-fw" aria-hidden="true"/>
                    </b-nav-item>


                    <b-nav-item :to="{name:'pageOrderStatus'}" class=" navigation-item"  >
                        <i class="fa fa2 fa-envelope  text-light  fa-fw" aria-hidden="true"/>
                    </b-nav-item>

                    <b-nav-item :to="{name:'pageSetting'}" class=" navigation-item">
                        <i class="fa fa1 fa-cog text-light  fa-fw" aria-hidden="true"/>
                    </b-nav-item>
                </b-nav>

            </div>
            <b-nav v-if="$auth.check()">
                <b-nav-item :to="{name:'pageLogin'}" @click="logout" class=" navigation-item">
                    <i class="fa fa2 fa-power-off text-light  fa-fw" aria-hidden="true"/>
                </b-nav-item>
            </b-nav>
        </div>
        <div class="main ">
            <b-container fluid>
                <b-row>
                    <b-col lg="4 " class="sidebar  mh-100">
                        <slot name="sidebar"></slot>
                    </b-col>
                    <b-col lg="8 " class="content  bg-light">
                        <slot name="content"></slot>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
export default {
  name: "LayoutAdmin",
  methods: {
    logout() {
      this.$auth.logout({
        makeRequest: true,
        redirect: "/login"
      });
    }
  }
};
</script>

<style>
.sidebar-tab {
  margin: 0 -15px;
  background-color: #f7f7f7;
}
.navigation-item .fa1 {
  font-size: 24px;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: -2px;
}
.navigation-item .fa2 {
  font-size: 22px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.layout-admin {
  clear: both;
}

.layout-admin .navigation {
  width: 60px;
  float: right;
  padding-top: 15px;
  position: fixed;
}

.layout-admin .main {
  width: calc(100% - 60px);
  float: right;
  margin-right: 60px;
  height: 100vh;
  overflow-y: scroll;
}

.layout-admin .content {
  border-right: solid 1px #ddd;
}

.mh-100 {
  min-height: calc(100vh);
}

.navigation-item {
  line-height: 0;
}

.navigation-item .active {
  background-color: #005cbf;
}

.layout-admin .navigation .nav-link {
  width: 60px;
  padding-right: auto;
  padding-left: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/LayoutAdmin.vue